// extracted by mini-css-extract-plugin
module.exports = {"info":"info_info__2Q1E9","important":"info_important__1KQW-","importantMessage":"info_importantMessage__2w7m8"};